import PermissionButton from "../../components/ui/PermissionButton";
import { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  Popup,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import DashboardLayout from "../Layouts/DashboardLayout";

const sampleTransfers = [
  {
    id: "TR-1001",
    from: "Central Factory",
    to: "City Outlet",
    product: "Kaju Katli",
    qty: 20,
    unit: "Kg",
    driver: "Ramesh",
    route: [
      [28.6139, 77.209],
      [28.5355, 77.391],
      [28.4595, 77.0266],
    ],
  },
  {
    id: "TR-1002",
    from: "Central Factory",
    to: "Main Branch",
    product: "Rasgulla",
    qty: 50,
    unit: "Kg",
    driver: "Suresh",
    route: [
      [28.6139, 77.209],
      [28.7041, 77.1025],
    ],
  },
];

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

export default function LiveTransportMap() {
  const [selected, setSelected] = useState(sampleTransfers[0]);
  const [driverPos, setDriverPos] = useState(sampleTransfers[0].route[0]);
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    if (!navigator.geolocation) return;

    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
        setDriverPos([pos.coords.latitude, pos.coords.longitude]);
      },
      (err) => console.log(err),
      { enableHighAccuracy: true }
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, []);

  return (
    <DashboardLayout>
      <div className="space-y-6 text-white">
        <h1 className="text-2xl font-serif">Live Transfers</h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {sampleTransfers.map((t) => (
            <div
              key={t.id}
              onClick={() => {
                setSelected(t);
                setDriverPos(t.route[0]);
                setShowMap(true);
              }}
              className={`p-4 rounded-xl cursor-pointer border ${
                selected.id === t.id
                  ? "bg-amber-400/20 border-amber-400"
                  : "bg-white/5 border-white/10"
              }`}
            >
              <p className="font-medium">{t.id}</p>
              <p className="text-sm text-gray-400">
                {t.from} → {t.to}
              </p>
              <p className="text-xs text-gray-500">
                {t.product} • {t.qty} {t.unit}
              </p>
              <p className="text-xs text-gray-500">Driver: {t.driver}</p>

              <PermissionButton permissionModule="demands" className="mt-3 text-xs text-amber-400 underline">
                View Live Map
              </PermissionButton>
            </div>
          ))}
        </div>

        {showMap && (
          <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center">
            <div className="relative w-full h-full p-6">
              {/* Close */}
              <PermissionButton permissionModule="demands"
                onClick={() => setShowMap(false)}
                className="absolute top-6 right-6 z-[999] px-4 py-2 rounded-lg bg-red-500 text-white"
              >
                ✕ Close
              </PermissionButton>

              <div className="w-full h-full rounded-xl overflow-hidden border border-white/10">
                <MapContainer
                  center={selected.route[0]}
                  zoom={12}
                  style={{ height: "100%", width: "100%" }}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="© OpenStreetMap"
                  />

                  <Polyline
                    positions={selected.route}
                    pathOptions={{ color: "#facc15", weight: 4 }}
                  />

                  <Marker position={driverPos}>
                    <Popup>
                      🚚 Driver: {selected.driver}
                      <br />
                      {selected.product}
                    </Popup>
                  </Marker>

                  <Marker position={selected.route[0]}>
                    <Popup>Factory</Popup>
                  </Marker>

                  <Marker position={selected.route[selected.route.length - 1]}>
                    <Popup>Destination</Popup>
                  </Marker>
                </MapContainer>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
